import React from 'react';
import Square from './Square';

const samePosition = (a, b) => a && b && a[0] === b[0] && a[1] === b[1];

const Board = ({ gameState, selectedPosition, onSquareClick }) => {
  const board = gameState.getBoard();
  const checkedKing = gameState.isInCheck(gameState.currentPlayer)
    ? gameState.findKing(gameState.currentPlayer)
    : null;
  const lastMove = gameState.lastMove;

  return (
    <div className="chess-board" role="grid" aria-label="Chess board, White side at the bottom">
      {Array.from({ length: 8 }, (_, rowIndex) => {
        const row = rowIndex + 1;
        return Array.from({ length: 8 }, (_, colIndex) => {
          const col = colIndex + 1;
          return (
            <Square
              key={`${row}-${col}`}
              row={row}
              col={col}
              piece={board[row][col]}
              isSelected={samePosition(selectedPosition, [row, col])}
              isPossibleMove={gameState.possibleMoves.some((move) => samePosition(move, [row, col]))}
              isLastMove={Boolean(lastMove && (samePosition(lastMove.from, [row, col]) || samePosition(lastMove.to, [row, col])))}
              isCheckedKing={samePosition(checkedKing, [row, col])}
              onClick={() => onSquareClick(row, col)}
            />
          );
        });
      })}
    </div>
  );
};

export default Board;
